import React, { useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { viewModeOn } from "../utilFunctions";
import { functionalities, PAGE_NAME_KEYS } from "../consts";

export const menuItems = [
  { key: functionalities.CLAIM_INTIMATION_TAB, label: "Claim Intimation", page: PAGE_NAME_KEYS.CLAIM_INTIMATION, icon: "fa-file-text-o" },
  { key: functionalities.CLAIM_PROCESSING_TAB, label: "Claim Processing", page: PAGE_NAME_KEYS.CLAIM_PROCESSING, icon: "fa-file-text-o" },
  { key: functionalities.CLAIM_BULK_PROCESS_TAB, label: "Claim Bulk Process", page: PAGE_NAME_KEYS.CLAIM_BULK_PROCESS, icon: "fa-file-text-o" },
  { key: functionalities.BULK_SURVEY_TAB, label: "Bulk Survey", page: PAGE_NAME_KEYS.BULK_SURVEY, icon: "fa-file-text-o" },
  { key: functionalities.USER_MANAGEMENT_TAB, label: "User Management", page: PAGE_NAME_KEYS.USER_MANAGEMENT, icon: "fa-file-text-o" },
  { key: functionalities.ROLE_MASTER_TAB, label: "Role Master", page: PAGE_NAME_KEYS.ROLE_MASTER, icon: "fa-file-text-o" },
  { key: functionalities.VENDOR_MASTER_TAB, label: "Vendor Master", page: PAGE_NAME_KEYS.VENDOR_MASTER, icon: "fa-file-text-o" },
  { key: functionalities.SURVEYOR_MASTER_TAB, label: "Surveyor Master", page: PAGE_NAME_KEYS.SURVEYOR_MASTER, icon: "fa-file-text-o" },
  { key: functionalities.INDEMNITY_MASTER_TAB, label: "Indemnity Master", page: PAGE_NAME_KEYS.INDEMNITY_MASTER, icon: "fa-file-text-o" },
  { key: functionalities.CLAIM_HANDLER_MASTER_TAB, label: "Claim Handler", page: PAGE_NAME_KEYS.CLAIM_HANDLER, icon: "fa-file-text-o" },
  { key: functionalities.COMPENSATION_MASTER_TAB, label: "Compensation Master", page: PAGE_NAME_KEYS.COMPENSATION_MASTER, icon: "fa-file-text-o" },
  { key: functionalities.EXCESS_MASTER_TAB, label: "Excess Master", page: PAGE_NAME_KEYS.EXCESS_MASTER, icon: "fa-file-text-o" },
  { key: functionalities.LOSS_RESERVE_MASTER_TAB, label: "Loss Reserve Master", page: PAGE_NAME_KEYS.LOSS_RESERVE_MASTER, icon: "fa-file-text-o" },
  { key: functionalities.ANIMAL_ATTACK_MASTER_TAB, label: "Animal Attack Master", page: PAGE_NAME_KEYS.ANIMAL_ATTACK, icon: "fa-file-text-o" },
  { key: functionalities.SAW, label: "SAW", page: PAGE_NAME_KEYS.SAW, icon: "fa-file-text-o" },
  { key: functionalities.SURVEY_MANAGEMENT_TAB, label: "Survey Management", page: PAGE_NAME_KEYS.SURVEY_MANAGEMENT, icon: "fa-file-text-o" }
];

const SideMenu = (props) => {
  const { roleDataCookie, page } = props;
  const navigate = useNavigate();

  const navigation = (url) => {
    navigate({ pathname: url });
  };

  const menuItemsToShow = useMemo(() => {
    return menuItems.filter(item => viewModeOn(item.key));
  }, []);

  return (
    <div className="col-auto col-md-3 col-xl-2 px-sm-2 px-0 sidebar">
      <div className="d-flex flex-column align-items-center align-items-sm-start px-3 pt-2 min-vh-100">
        <div className="text-center">
          <img alt="logo" className="pl-2 py-5" src="/kshemaImages/Kshema Logo Black and Blue.svg" width="60%" />
        </div>
        <ul className="nav nav-pills flex-column mb-sm-auto mb-0 align-items-center align-items-sm-start" id="menu">
          {menuItemsToShow.map((item) => (
            <div
              key={item.key}
              className={`list_menu align-middle px-0 pt-3 pointer ${page === item.page ? "list_menu_active" : ""}`}
              onClick={() => navigation(`/dashboard/${item.page}`)}
            >
              <i className={`fa ${item.icon}`} />
              <span className="sidebar_text ms-2 d-none d-sm-inline">{item.label}</span>
            </div>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default SideMenu;
